import React from 'react'
import { useSelector } from 'react-redux'
import {
  useMap,
  useMapsLibrary,
  // eslint-disable-next-line
} from '@vis.gl/react-google-maps/dist/index.umd.js'
import {
  setActiveLotId,
  setDatasetLayer,
  setDestination,
  setDirectionRoutes,
  setMarkerInfo,
  updateBottomSheet,
} from '../../redux/myMapsSlice'
import { MOBILEPARKINGINFOWINDOW } from '../../../../utils/constants'
import {
  removePolylineStyle,
  setPolylineStyle,
} from '../../../../utils/helpers'

// filterBy takes an array ["employee", "student"] or empty [] includes all filter by Region Code
function PolylineFromDataset({
  showParkingLots,
  dispatch,
  parkingLotData,
  isMobile,
  filterBy,
  additionalFilters,
  userParkingPermitData,
  darkMode,
}) {
  const map = useMap()
  const infowWindowInstance = useMapsLibrary('maps') // load 'core' library to get access to InfoWindow
  const datasetLayer = map.getDatasetFeatureLayer(
    'd744edd6-00be-46d3-bf7b-3efc87c9bf40',
  )
  const { activeLotId } = useSelector((s) => s.maps)
  //   const [activeLotId, setActiveLotId] = React.useState(null)

  React.useEffect(() => {
    if (datasetLayer) {
      dispatch(setDatasetLayer(datasetLayer))
    }
  }, [datasetLayer])

  React.useEffect(() => {
    if (!map || !infowWindowInstance) return

    const listener = datasetLayer.addListener('click', (event) => {
      const clickedId = event.features[0].datasetAttributes?.Parking_ID
      dispatch(setActiveLotId(clickedId))

      const lot = parkingLotData.find((lotItem) => lotItem?.mapId === clickedId)

      const parkingLotClicked = lot ?? {
        propertyName: event.features[0].datasetAttributes?.Lot_Name,
        address1: event.features[0].datasetAttributes?.Address,
        cityCode: event.features[0].datasetAttributes?.Campus,
        ...event.features[0].datasetAttributes,
      }
      console.log('parkingLotClicked ', parkingLotClicked)
      dispatch(setMarkerInfo({ ...parkingLotClicked, isActive: true }))
      dispatch(
        setDestination(
          `${parkingLotClicked?.address?.address1}, ${parkingLotClicked?.address?.cityCode}`,
        ),
      )
      dispatch(setDirectionRoutes([]))
      if (isMobile) {
        dispatch(updateBottomSheet(MOBILEPARKINGINFOWINDOW))
      }
    })
    // eslint-disable-next-line
    return () => listener.remove() // cleanup
  }, [map, infowWindowInstance, parkingLotData])

  React.useEffect(() => {
    if (!map) return

    if (showParkingLots === false) {
      datasetLayer.style = removePolylineStyle
    } else {
      datasetLayer.style = ({ feature }) =>
        setPolylineStyle({
          feature,
          parkingLotData,
          filterBy,
          activeLotId,
          additionalFilters,
          userParkingPermitData,
          darkMode,
        })
    }
  }, [
    map,
    datasetLayer,
    showParkingLots,
    filterBy,
    activeLotId,
    parkingLotData,
    additionalFilters,
    userParkingPermitData,
    darkMode,
  ])

  return null
}

export default PolylineFromDataset
